import {FloatingPanel, FloatingPanelProps} from './components/floating-panel'
import {createOverlay} from '@chakra-ui/react'

export const floatingPanel = createOverlay<FloatingPanelProps>(props => {
  return <FloatingPanel {...props} />
})